import { AppLogo } from 'components/_common/Icons';
import LazyImage from 'components/_common/LazyImage';
import { FFL_ROLE_SLUG } from 'config/app.config';
import { getFullName, getTruncatedString } from 'helpers/CommonHelper';
import { t } from 'i18next';
import DarkTopbar from 'modules/admin/components/Header/DarkTopbar';
import DarkSidebar from 'modules/admin/components/Navbars/DarkSidebar';
import { getSidebarMenu } from 'modules/admin/components/Navbars/sidebarConfig';
import { useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import ProtectedAdminRoute from 'routes/admin/ProtectedAdminRoute';
import 'modules/admin/assets/scss/adminCustom.scss';
import {
  userCurrentRoleSelector,
  userProfileImageSelector,
  userProfileInfoSelector,
  userFFLInfoSelector,
} from 'store/auth/selectors/authSelectors';
import { useAppSelector } from 'store/hooks';

export default function AdminMainDarkLayout() {
  const [collasped, setCollasped] = useState<boolean>(true);
  const userProfileInfo = useAppSelector(userProfileInfoSelector);
  const userFFLInfo = useAppSelector(userFFLInfoSelector);
  const userRoleInfo = useAppSelector(userCurrentRoleSelector);
  const userProfileImage = useAppSelector(userProfileImageSelector);
  const sidebarMenu = getSidebarMenu();

  const toggleSidebar = (): void => {
    setCollasped((prev) => !prev);
  };

  const userInfo = useMemo(() => {
    const userData = {
      name: '',
      email: userProfileInfo?.email || '',
    };
    if (userProfileInfo && userRoleInfo) {
      if (userRoleInfo?.slug == FFL_ROLE_SLUG && userFFLInfo?.business_name) {
        userData.name = userFFLInfo?.business_name ?? '';
      }
      userData.name = getFullName(userProfileInfo.first_name, userProfileInfo.last_name);
    }
    return userData;
  }, [userProfileInfo, userFFLInfo, userRoleInfo]);

  return (
    <ProtectedAdminRoute>
      <div className="admin-layout dark-layout">
        <DarkSidebar
          collasped={collasped}
          menu={sidebarMenu}
          width={250}
          Header={() => (
            <div className="flex-center p-2">
              <img src={AppLogo} alt="Logo" style={{ width: '80.36%' }} />
            </div>
          )}
          Footer={() => (
            <>
              <div className="profile-card d-flex align-items-center p-3">
                <div className="profile-icon me-2">
                  <LazyImage
                    src={userProfileImage}
                    alt={t('profile')}
                    className="img-fluid ffl-picture-radius profile-img"
                  />
                </div>
                <div className="mb-0">
                  <h5 className="mb-1">John Miller</h5>
                  <p className="mb-0">j.miller@mlgs.com</p>
                </div>
                <div>
                  <h5 className="mb-1" title={userInfo?.name}>
                    {userInfo?.name ? getTruncatedString(userInfo?.name, 20) : ''}
                  </h5>
                  <p className="mb-0 text-muted" title={userInfo?.email}>
                    {userInfo?.email ? getTruncatedString(userInfo?.email, 20) : ''}
                  </p>
                </div>
              </div>
            </>
          )}
        />
        <div className={`flex-grow-1 ${collasped ? 'main-content' : 'main-content-full'}`}>
          <DarkTopbar onToggle={toggleSidebar} />
          <div className="p-2">
            <Container fluid className="p-2 rounded-1 content">
              <Outlet />
            </Container>
          </div>
        </div>
      </div>
    </ProtectedAdminRoute>
  );
}
